import { RouteObject } from 'react-router-dom'
import NovaOportunidadePage from '@/pages/reservas/nova/NovaOportunidadePage'

/**
 * Rotas do A07 (Onda 3) — Nova oportunidade em página, substituindo o modal de 3
 * passos de Minhas Reservas. O botão "+ Nova oportunidade" aponta para cá, e os
 * links antigos por query string (Dashboard, ClientesList, retorno do ClienteForm)
 * foram repontados para cá na Onda 8 / A16; o modal antigo saiu de Minhas Reservas.
 *
 * `/reservas/nova` convive com `/reservas/:id/...`: o react-router ranqueia
 * segmento estático acima de dinâmico, então "nova" nunca é engolido como :id.
 */
const rotasA07: RouteObject[] = [
  { path: 'reservas/nova', element: <NovaOportunidadePage /> },
]

export default rotasA07
